// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2676":"82fbc930","4494":"82fbc930","5036":"82fbc930","6199":"59066f8f","6373":"c2b21898","6831":"59066f8f","8125":"c2b21898","8754":"c2b21898","9212":"59066f8f","9525":"ca6d3b46"}[chunkId] + ".chunk.css";
};